import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { GUIDE_SECTIONS } from './guideContent';
import type { GuideArticle } from './guideContent';

export interface SearchResult {
  article: GuideArticle;
  sectionId: string;
  score: number;
}

export function useGuideSearch(query: string, isAdmin: boolean): SearchResult[] {
  const { t } = useTranslation('guide');
  const [results, setResults] = useState<SearchResult[]>([]);

  useEffect(() => {
    if (!query || query.trim().length < 2) {
      setResults([]);
      return;
    }

    const timer = setTimeout(() => {
      const q = query.toLowerCase().trim();
      const scored: SearchResult[] = [];

      for (const section of GUIDE_SECTIONS) {
        if (section.adminOnly && !isAdmin) continue;
        for (const article of section.articles) {
          let score = 0;
          const title = t(article.titleKey, '').toLowerCase();
          const body = t(article.bodyKey, '').toLowerCase();

          if (title.includes(q)) score += 10;
          for (const tag of article.tags) {
            if (tag.includes(q) || q.includes(tag)) score += 5;
          }
          if (body.includes(q)) score += 2;

          if (score > 0) {
            scored.push({ article, sectionId: section.id, score });
          }
        }
      }

      scored.sort((a, b) => b.score - a.score);
      setResults(scored);
    }, 200);

    return () => clearTimeout(timer);
  }, [query, t, isAdmin]);

  return results;
}
